import { connect } from 'react-redux';
import SidePanelLayout from './layout';
import { getSidePanelWidth, userHasCurrentFormPermission, showHeader, showTitleHeader } from '../../redux/modules/entities/selectors';
export const mapStateToProps = (state, props) => {
return {
  slidingWidth: getSidePanelWidth(state),
  userHasCurrentFormPermission: userHasCurrentFormPermission(state),
  showHeader: showHeader(state),
  showTitleHeader:showTitleHeader(state)

}}

export default connect(mapStateToProps)(SidePanelLayout);
